import React from 'react'
import './Footer.css'

function Footer() {
    const date = new Date()
    const year = date.getFullYear()
    return (
        <footer className='footer'>
            <div className='footerContent'>
                <p>&copy; {year} Utsab Khatiwada</p>
                <span className='footerText'>| Crafted in clean code</span>
            </div>
        </footer>
    )
}

export default Footer
